var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLitecoin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4312 0 0 13.4312 0 30C0 46.5688 13.4312 60 30 60C46.5688 60 60 46.5688 60 30C59.9808 13.4395 46.5605 0.019226 30 0ZM30 54.0001C16.745 54.0001 5.99991 43.255 5.99991 30C5.99991 16.745 16.745 5.99991 30 5.99991C43.255 5.99991 54.0001 16.745 54.0001 30C53.985 43.2486 43.2486 53.985 30 54.0001Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 9.00012C18.402 9.00012 9 18.4021 9 30C9 41.5979 18.402 50.9999 29.9999 50.9999C41.5978 50.9999 50.9998 41.5979 50.9998 30C50.9865 18.4076 41.5923 9.0134 29.9999 9.00012ZM37.4999 40.5002H25.5001C24.6715 40.5002 24 39.8287 24 39.0001C24 38.9292 24.005 38.8582 24.0151 38.7877L25.144 30.8844L22.8638 31.4548C22.7448 31.485 22.6226 31.5001 22.4999 31.5001C21.6714 31.4992 21.0007 30.8272 21.0012 29.9987C21.0021 29.3111 21.4699 28.7123 22.1369 28.5448L25.6017 27.6787L27.0148 17.7874C27.132 16.967 27.8919 16.3976 28.7122 16.5148C29.5325 16.632 30.102 17.3918 29.9848 18.2122L28.7443 26.8932L34.1363 25.5451C34.9387 25.3405 35.7549 25.8252 35.9591 26.6277C36.1637 27.4301 35.6789 28.2463 34.8765 28.451C34.8719 28.4519 34.8673 28.4532 34.8627 28.4542L28.2856 30.0984L27.2286 37.5H37.4999C38.3285 37.5 39 38.1716 39 39.0001C39 39.8282 38.3285 40.5002 37.4999 40.5002Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoin1);
export default __webpack_public_path__ + "static/media/litecoin-1.fab294abba5c09026df7cfe7c98054eb.svg";
export { ForwardRef as ReactComponent };